import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import CopyButton from "@/components/CopyButton";
import Placeholder from "@/components/Placeholder";
import { Check, Circle, ArrowUpRight, PartyPopper } from "lucide-react";

const STEPS = [
  { id: 1, time: "Friday Night", asset: "/portal/training", assetLabel: "Module 1" },
  { id: 2, time: "Saturday Morning", asset: "/portal/assets", assetLabel: "Asset Vault" },
  { id: 3, time: "Saturday Afternoon", asset: "/portal/demo-offer", assetLabel: "Demo Offer" },
  { id: 4, time: "Sunday Morning", asset: "/portal/scripts", assetLabel: "Scripts" },
  { id: 5, time: "Sunday Night", asset: "/portal/book-call", assetLabel: "Launch Call" },
];

export default function WeekendPlan() {
  const { progress, refreshProgress } = useAuth();
  const done = new Set(progress?.weekend_steps_completed || []);
  const allDone = STEPS.every((s) => done.has(s.id));

  const toggle = async (id, completed) => {
    await api.post("/progress/weekend-step", { step_id: id, completed });
    refreshProgress();
  };

  const shareLink = `${window.location.origin}/`;

  return (
    <div data-testid="weekend-plan-page">
      <div className="eyebrow" style={{ color: "#2038E6" }}>The Weekend Plan</div>
      <h1 className="h-display" style={{ fontSize: "clamp(32px,5vw,48px)", marginTop: 8 }}>Friday to Sunday</h1>
      <p style={{ color: "var(--muted)", marginTop: 10 }}>Check each block as you go. Finish all five and you are open for business.</p>

      {allDone && (
        <div data-testid="celebration" style={{ marginTop: 24, background: "#FFDF57", borderRadius: 16, padding: 26 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <PartyPopper size={26} />
            <span className="font-archivo" style={{ fontWeight: 900, textTransform: "uppercase", fontSize: 24 }}>You're open for business</span>
          </div>
          <p style={{ marginTop: 8 }}>Now refer one person and your $97 is covered.</p>
          <div style={{ marginTop: 12 }}><CopyButton text={shareLink} label="Copy share link" testId="celebration-share" /></div>
        </div>
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: 14, marginTop: 26 }}>
        {STEPS.map((s) => {
          const isDone = done.has(s.id);
          return (
            <div key={s.id} className="card-paper" data-testid={`weekend-step-${s.id}`} style={{ padding: 20, display: "flex", gap: 16, alignItems: "flex-start" }}>
              <button
                onClick={() => toggle(s.id, !isDone)}
                data-testid={`weekend-step-check-${s.id}`}
                aria-label={isDone ? "Mark incomplete" : "Mark complete"}
                style={{
                  width: 30, height: 30, borderRadius: 8, flexShrink: 0, cursor: "pointer",
                  border: isDone ? "none" : "1px solid var(--line)",
                  background: isDone ? "#2038E6" : "#fff", color: "#fff",
                  display: "flex", alignItems: "center", justifyContent: "center", marginTop: 2,
                }}
              >
                {isDone ? <Check size={18} /> : <Circle size={12} color="#D9DDD6" />}
              </button>
              <div style={{ flex: 1 }}>
                <div className="font-mono-plex" style={{ fontSize: 11, color: "#2038E6", textTransform: "uppercase", letterSpacing: "0.08em" }}>{s.time}</div>
                <div className="font-archivo" style={{ fontWeight: 800, fontSize: 18, marginTop: 4 }}>Step {s.id}</div>
                <p style={{ color: "var(--muted)", marginTop: 4 }}><Placeholder>what to do this block</Placeholder></p>
                <Link to={s.asset} className="font-archivo" style={{ marginTop: 8, display: "inline-flex", alignItems: "center", gap: 6, color: "#2038E6", fontWeight: 700, textTransform: "uppercase", fontSize: 12, textDecoration: "none" }}>
                  Open {s.assetLabel} <ArrowUpRight size={14} />
                </Link>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
